import { render, staticRenderFns } from "./ListAdminConfigView.vue?vue&type=template&id=4a44ac72&"
import script from "./ListAdminConfigView.vue?vue&type=script&lang=ts&"
export * from "./ListAdminConfigView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports